import { memo } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons/faFloppyDisk'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import { alertErrorMessage, throwSuccessMessage } from '../../utils/Errors'
import { FormattedMessage } from 'react-intl'
import { fetchProductSchemaAndConfig } from '../../store/async-thunks/configurations/fetchProductSchemaAndConfig'

interface SyncConfigUpdateProps {
    guid: string
}

export const SyncConfigUpdate = memo(function SyncConfigUpdate(props: SyncConfigUpdateProps) {
    const dispatch = useAppDispatch()

    const handleSync = () => {
        dispatch(
            fetchProductSchemaAndConfig({ guid: props.guid, forceUpdate: true })
        )
            .then(() => {
                throwSuccessMessage('Configuration updated')
            })
            .catch((e: any) => {
                alertErrorMessage(e)
            })
    }

    return (
        <span
            className="d-flex align-items-center gap-2 mx-3"
        >
            <span
                className="d-flex align-items-center gap-2 px-2 "
                style={{
                    backgroundColor: '#FDF1DF',
                    borderRadius: '6px',
                    padding: '5px',
                }}
            >
                <FontAwesomeIcon
                    color={'#DBB47A'}
                    icon={faFloppyDisk}
                />
                <FormattedMessage id="buttons.syncConfigMsg" />
            </span>
            <span className="d-flex gap-2">
                <button
                    type="button"
                    className="app-btn-main app-btn-apply"
                    onClick={handleSync}
                >
                    Sync
                </button>
            </span>
        </span>
    )
})
